import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from '../locales/en.json';
import esTranslations from '../locales/es.json';

export const DEFAULT_LNG = 'en';

i18n.use(initReactI18next).init({
  fallbackLng: DEFAULT_LNG,
  missingKeyHandler: (lng, ns, key) => {
    const error = `Missing i18n key ${[lng].flat().join(',')}.${ns}.${key}`;

    if (process.env.NODE_ENV === 'production') {
      console.error(error);
    } else {
      throw new Error(error);
    }
  },
  parseMissingKeyHandler: (key, _defaultValue, options) => {
    const { lng, ns } = options;

    return `Translation missing: ${lng || 'en'}.${ns}.${key}`;
  },
  resources: {
    en: enTranslations,
    es: esTranslations,
  },
});

export default i18n;
